import axios from "axios";
import { DataResponse } from "models/common/responseObjects";


export class UpgradeProcessApi {
    static UpgradeManagedCatalogues = async () => axios.post<DataResponse<boolean>>(`api/v1/UpgradeProcess/UpgradeManagedCatalogues`);
}